import PropTypes from "prop-types";

import { formatBookDetailUrl } from "../../helpers/Helper";
import slugify from "slugify";
import Link from "next/link";
import NextImage from "@components/Image/NextImage";

import styles from "./BookCard.module.css";

const BookCard = (props) => {
  const { displayName = "BookCard" } = props;
  let cleanDescription = props.description;
  let readUrl = formatBookDetailUrl(props.isbn, slugify(props.title));

  return (
    <div className={[styles[displayName], displayName, "row"].join(" ")}>
      <div className={["columns", "slider-image", props.imageClasses].join(" ")}>
        <Link href={readUrl}>
          <NextImage
            ImageUrl={props.image && props.image ? props.image : ""}
            Title={props.title}
            Alt_Text={props.title}
            width={300}
            height={457}
            style={{ width: "300px", height: "auto" }}
          />
        </Link>
      </div>
      <div
        className={[
          "columns",
          styles["slider-details"],
          "slider-details",
          props.detailsClasses,
        ].join(" ")}
      >
        <Link href={readUrl} className={[styles["title-link"], "title-link"].join(" ")}>
          <h2 className={styles.BookCardHeading}>
            <span dangerouslySetInnerHTML={{ __html: props.title }} />
          </h2>
        </Link>

        <div
          className={[styles["book-card-description"], "book-card-description"].join(" ")}
          dangerouslySetInnerHTML={{ __html: cleanDescription }}
        />
        <div className={[styles["text-gradient-overlay"], "text-gradient-overlay"].join(" ")}></div>

        <Link href={readUrl} className="readmore">
          Read More
        </Link>
      </div>
    </div>
  );
};

export default BookCard;

BookCard.propTypes = {
  displayName: PropTypes.string,
  title: PropTypes.string,
  authors: PropTypes.array,
  description: PropTypes.string,
  image: PropTypes.string,
  isbn: PropTypes.string,
  slug: PropTypes.string,
  imageClasses: PropTypes.string,
  detailsClasses: PropTypes.string,
};
